import Contact6 from './Contact6'
export default Contact6
